<template>
  <div id="app">
    <!--导航条-->
    <gheader></gheader>
    <!--logo一行-->
    <glogo></glogo>
    <!--红色导航-->
    <grednav></grednav>
    <!--主要内容展示-->
    <div class="row-content" @click="showCondition">
      <div class="main-width">
        <div class="project-sort pull-left">
          <lnav ref="lnav" v-on:filtrate="showCondition"></lnav>
          <!--<lnav id="lnav2"></lnav>-->
        </div>
        <div class="notice-content pull-right">
          <showtable ref="showtable"  v-bind:captionTitle="captionTitle" v-bind:condition="checked" v-bind:dataUrl="tableDataUrl"></showtable>
        </div>
      </div>
    </div>
    <div class="nav-query">
      <div class="u-input-group u-has-feedback u-left margin-right-10">
          <input type="text" class="u-form-control md" placeholder="请输入项目名称" v-model = "searchKeyword1" />
        </div>
        <div class="u-input-group u-has-feedback u-left margin-right-10">
            <input type="text" class="u-form-control md" placeholder="请输入组织机构" v-model = "searchKeyword0" />
            <!-- <button class="btn btn-white no-btn-outline" type="submit">
              <i class="fa fa-search"></i>
            </button> -->
        </div>
        <button class="u-button u-button-info u-right" @click="search">查询</button>
    </div>
    <!--合作供应商-->
    <gsupplier></gsupplier>
    <!--footer-->
    <gfooter></gfooter>
  </div>
</template>

<script>
  /*eslint-disable*/
  import gheader from 'components/G-header'
  import glogo from 'components/G-logo'
  import grednav from 'components/G-rednav'
  import gsupplier from 'components/G-supplier'
  import gfooter from 'components/G-footer'
  import lnav from 'components/L-nav'
  import showtable from 'components/show-table'
  import {apiLinks} from '../../api/links'
  import Bus from '../../eventbus/bus'
  import EVENTLIST from '../../eventbus/eventlist'

  export default {
    name: 'app',
    components: {
      gheader,
      glogo,
      grednav,
      gsupplier,
      gfooter,
      lnav,
      showtable
    },
    data () {
      return {
        links: {
          title: '友情链接',
          content: [
            '南方水泥官方网站',
            '中国建筑材料集团有限公司',
            '中国建材股份有限公司',
            '南方水泥有限公司成员企业'
          ]
        },
        captionTitle: [
          '询价公告',
          '招标公告',
          '中标公告'
          // '竞价公告',
          // '竞价性谈判'
        ],
        checked: '',
        tableDataUrl: apiLinks.purchasetableDate,
        searchKeyword0: '',
        searchKeyword1: ''
      }
    },
    methods: {
      showCondition: function () {
        this.checked = this.$refs.lnav.condition
      },
      search: function () {
        Bus.$emit("ORGDATA_SEARCH", this.searchKeyword0,this.searchKeyword1)
      }
    }
  }
</script>
<style lang="less">
  @import './purchase.less';
</style>



// WEBPACK FOOTER //
// purchase.vue?3d5c2bd6